// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__O8kZ4","table":"Table_table__GvWLd","fixedHeader":"Table_fixedHeader__QzLpq"};